import React from 'react'

const CarPrinter = () => {
  return (
    <div>
      
    </div>
  )
}

export default CarPrinter
